import { getRoutePathWithId } from '@/utils/router-utils';

export const SELL_PREFIX = 'sell';
export const BUY_PREFIX = 'buy';
export const ADMIN_PREFIX = 'admin';
export const ACCOUNT_PREFIX = 'account';
export const BULK_UPLOAD_PREFIX = 'inventory/upload';

export class RoutePaths {
  static ROOT = '';
  static ACTIVATION = 'activation'; // TODO: pluralize
  static ACTIVATION_DETAIL = 'activation/:id'; // TODO: pluralize
  static INVENTORY = 'inventory';
  static INVENTORY_SHARED_WITH_ME = 'shared-with-me';
  static INVENTORY_CREATE = 'inventory/create';
  static INVENTORY_DETAIL = 'inventory/:id';
  static INVENTORY_EDIT = 'inventory/:id/edit';
  static DASHBOARD = 'dashboard';
  static BULK_UPLOAD_SELECT = 'select';
  static BULK_UPLOAD_REVIEW = 'review';
  static PREFERENCES = 'preferences';
  static SETTINGS = 'settings';
  static PAYMENTS = 'payments';
  static MY_SETTINGS = 'my-settings';
  static SUBSCRIPTION = 'subscription';
  static PROFILE_EDIT = 'profile/edit';
  static INVITATIONS = 'invitation/:id';
  static QR_LABEL = {
    STOREFRONT: 'qr-label/storefronts/:id',
    EXHIBITOR: 'qr-label/exhibitors/:id',
    LISTING: 'qr-label/listings/:id',
  };
  static SELLER = 'sellers/:id';
  static LISTINGS = 'listings/:id';

  static PAYMENT_ONBOARDING = 'profile/payment-info';
  static SELL = {
    REQUESTS: `${SELL_PREFIX}/requests`,
    REQUEST_DETAIL: `${SELL_PREFIX}/requests/:id`,
    SALES_AGREEMENT: `${SELL_PREFIX}/sales-agreements`,
    SALES_AGREEMENT_DETAILS: `${SELL_PREFIX}/sales-agreements/:id`,
    SALES_AGREEMENT_CREATE: `${SELL_PREFIX}/sales-agreements/create`,
    SALES_AGREEMENT_DETAIL: `${SELL_PREFIX}/sales-agreements/:id`,
    TRANSFER_CREATE: `${SELL_PREFIX}/sales-agreements/create-transfer`,
    TRANSFER_DETAILS: `${SELL_PREFIX}/transfers/:id`,
  };
  static BUY = {
    REQUESTS: `${BUY_PREFIX}/requests`,
    REQUEST_DETAIL: `${BUY_PREFIX}/requests/:id`,
    SALES_AGREEMENT: `${BUY_PREFIX}/sales-agreements`,
    SALES_AGREEMENT_DETAILS: `${BUY_PREFIX}/sales-agreements/:id`,
    TRANSFER_DETAILS: `${BUY_PREFIX}/transfers/:id`,
  };
  static ADMIN = {
    EMAILS: `${ADMIN_PREFIX}/emails`,
    USER_ACCESS: `${ADMIN_PREFIX}/user-access`,
  };
  static ACCOUNT = {
    ROOT: ACCOUNT_PREFIX,
    PREFERENCES: `${ACCOUNT_PREFIX}/${RoutePaths.PREFERENCES}`,
    SETTINGS: `${ACCOUNT_PREFIX}/${RoutePaths.SETTINGS}`,
    MY_SETTINGS: `${ACCOUNT_PREFIX}/${RoutePaths.MY_SETTINGS}`,
    PAYMENTS: `${ACCOUNT_PREFIX}/${RoutePaths.PAYMENTS}`,
    SUBSCRIPTION: `${ACCOUNT_PREFIX}/${RoutePaths.SUBSCRIPTION}`,
    TEAM: `${ACCOUNT_PREFIX}/team`,
  };
  static BULK_UPLOAD = {
    ROOT: BULK_UPLOAD_PREFIX,
    SELECT: `${BULK_UPLOAD_PREFIX}/${RoutePaths.BULK_UPLOAD_SELECT}`,
    REVIEW: `${BULK_UPLOAD_PREFIX}/${RoutePaths.BULK_UPLOAD_REVIEW}`,
  };
  static LINK_IN_BIO = 'link-in-bio';
}

export const getRoute = (path: string, id?: string) => {
  const fullPath = `${RoutePaths.ROOT}/${path}`;
  if (id) {
    return getRoutePathWithId(fullPath, id);
  }
  return fullPath;
};
